import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { environment } from '@app/../environments/environment';

/** Reserve une route aux builds de developpement. Environnement de l'app hote, comme AuthGuard. */
@Injectable({
    providedIn: 'root'
})
export class DebugOnlyGuard implements CanMatch {
    // CanMatch et non CanActivate : en production la route n'est jamais retenue, donc jamais chargee.
    canMatch(route: Route, segments: UrlSegment[]): boolean {
        return !environment.production;
    }
}
